import { Component } from "react";

class ErrorBoundary extends Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-[#050505] p-8 text-center text-white">
          <div>
            <p className="font-display text-2xl font-bold uppercase">Something went wrong</p>
            <a href="/" className="mt-4 inline-block font-display text-sm uppercase tracking-[0.25em] text-[#E60000] underline">
              Back home
            </a>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
